import {
  SET_PERIOD_MONTH_DATE,
  USER_DATA_CONSTANT,
} from "../../_constants/Redux/userData.constant";

const INITIAL_STATE = {
  projectMenu: [],
  projectId: null,
  siteId: null,
  siteIds: [],
  columnFields: {},
  periodMonthData: {},
};

export default function userData(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_DATA_CONSTANT.PROJECT_MENU:
      return {
        ...state,
        projectMenu: [...action.data],
      };
    case USER_DATA_CONSTANT.ADD_PROJECT_MENU:
      let projectMenu = state.projectMenu;
      projectMenu.splice(1, 0, action.data);
      return {
        ...state,
        projectMenu: projectMenu,
      };
    case USER_DATA_CONSTANT.PROJECT_ID:
      return {
        ...state,
        projectId: action.data,
      };
    case USER_DATA_CONSTANT.SITE_ID:
      return {
        ...state,
        siteId: action.data,
      };
    case USER_DATA_CONSTANT.ADD_SITE_IDS:
      return {
        ...state,
        siteIds: action.data,
      };
    case USER_DATA_CONSTANT.TOGGLE_COLUMN:
      return {
        ...state,
        columnFields: { ...state.columnFields, ...action.data },
      };
    case SET_PERIOD_MONTH_DATE:
      return {
        ...state,
        periodMonthData: { ...state.periodMonthData, ...action.data },
      };
    default:
      return state;
  }
}
